import React, { useState, useEffect } from "react";
import usePageTitle from "../hooks/usePageTitle";
import Footer from "../components/Footer";
import Preloader from "../components/Preloader";
import PageChrome from "../components/PageChrome";
import HeroSection from "../components/HeroSection";
import LatestProfilesTicker from "../components/LatestProfilesTicker";
import QuickAccess from "../components/QuickAccess";
import CustomerReviews from "../components/CustomerReview";
import WhyChooseUs from "../components/WhyChooseUs";
import HowItWorks from "../components/HowItWorks";
import RecentCouples from "../components/RecentCouples";
import MeetOurTeam from "../components/MeetOurTeam";
import BlogSection from "../components/BlogSection";
import FindMatchSection from "../components/FindMatchSection";
import CopyRight from "../components/CopyRight";
import MyAboutUS from "../components/MyAboutUS";
import SEOSection from "../components/SEOSection";

const Home = () => {
  usePageTitle("Home", {
    suffix: false,
    description:
      "Dewangan Links — India's most trusted matrimony platform for the Dewangan community. Browse verified profiles and find your perfect life partner.",
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Preloader />;
  }

  return (
    <div className="str">
      <PageChrome />
      <HeroSection />
      <LatestProfilesTicker />
      <QuickAccess />
      <CustomerReviews />
      <WhyChooseUs />
      <MyAboutUS />
      <HowItWorks />
      <RecentCouples />
      <MeetOurTeam />
      <BlogSection />
      <FindMatchSection />
      <SEOSection />
      <Footer />
      <CopyRight />
    </div>
  );
};

export default Home;
